module.exports = __webpack_public_path__ + "img/default_poster.5da7148e.jpg";